import firebase from '../../../firebase'

var db = firebase.firestore();

export const sendMessage = (conversationUid, messageData, next) => {

  var conversationRef = db.collection("conversations").doc(conversationUid);

  conversationRef.get()

    .then((conversationResponse) => {

      var {docs} = conversationResponse;

      if (conversationResponse.exists) {

        var doc = conversationResponse
        var conversation = doc.data();

        conversation.id = doc.id;

        return conversation
      }

    })

    .then((conversation) => {

      return conversationRef.update({
        messages: [...conversation.messages, messageData]
      })

    })

    .catch(function(error) {

      return next({
        type: "conversationError",
        error
      })

    });

}





// WEBPACK FOOTER //
// ./src/Components/MessagingScreen/middleware/messages-fire.js